import {forwardRef, useCallback} from 'react';
import PropTypes from 'prop-types';
import {COLUMN_GAP, useDailyCalendarStyles} from '../edReviewCalendarDaily';
import isEmpty from 'lodash/isEmpty';
import Typography from '@mui/material/Typography';
import clsx from 'clsx';

const ColumnHeader = forwardRef(({ columns, columnHeaderStyles }, ref) => {
  const classes = useDailyCalendarStyles();

  const getClinicianTitle = (clinician) => {
    return clinician?.title || clinician?.name || clinician?.__name;
  };

  const getClinician = (clinician) =>
    clinician?.name || clinician?.__name || clinician;

  const getClinicianData = useCallback((clinician, col) => {
    return <>
      {getClinicianTitle(clinician)}
      {getClinician(col?.assignedClinician || clinician)}
    </>
  }, []);

  const getEdReviewTitle = (col) => {
    return col?.title;
  }

  return !isEmpty(columns) && columns.length > 1 ? (
    <div
      ref={ref}
      style={{ gap: COLUMN_GAP, backgroundImage: 'unset' }}
      className={clsx(classes.columnHeader, classes.timelineContainer, 'scroll-normal-white')}
    >
      {columns.map((col, index) => (
        <div
          key={`${col?.id} + ${index}`}
          style={columnHeaderStyles}
          className={classes.columnClinicianHeader}
        >
          {col?.specialty && <div className={classes.specialty}>
            {col?.specialty?.__code}
          </div>}

          <div>
            <Typography
              variant="h6"
              component="h6"
              style={{ display: "flex", alignItems: "center", gap: 5 }}
            >
              {col?.clinician ?
                getClinicianData(col?.clinician, col) :
                getEdReviewTitle(col, index)
              }
            </Typography>
          </div>
        </div>
      ))}
    </div>
  ) : null;
});

ColumnHeader.propTypes = {
  columns: PropTypes.array,
  columnHeaderStyles: PropTypes.object
};

export default ColumnHeader;